import PaymentHistory from "../../../components/admin/all-payments/payment-history";

const PaymentsHistoryPage = () => {
  return (
    <PaymentHistory />
  );
};

export default PaymentsHistoryPage;